<template>
	<tr>
		<td class="fragen">
			<span class="title"> {{ count + 1 }}. {{ rowTitle }} <br /></span>
			<span>{{ item.text }}</span>
		</td>
		<td class="radiobuttons" @click="handleTd(1)">
			<input type="radio" v-bind="{ name: 'i' + item.id, id: 'i' + item.id + '_1' }" value="1" v-model="response.value" @change="handleChange" />
			<label v-html="mwpLabel[lang][0]" v-bind="{ for: 'i' + item.id + '_1' }"></label>
		</td>
		<td class="radiobuttons" @click="handleTd(2)">
			<input type="radio" v-bind="{ name: 'i' + item.id, id: 'i' + item.id + '_2' }" value="2" v-model="response.value" @change="handleChange" />
			<label v-html="mwpLabel[lang][1]" v-bind="{ for: 'i' + item.id + '_2' }"></label>
		</td>
		<td class="radiobuttons" @click="handleTd(3)">
			<input type="radio" v-bind="{ name: 'i' + item.id, id: 'i' + item.id + '_3' }" value="3" v-model="response.value" @change="handleChange" />
			<label v-html="mwpLabel[lang][2]" v-bind="{ for: 'i' + item.id + '_3' }"></label>
		</td>
		<td class="radiobuttons" @click="handleTd(4)">
			<input type="radio" v-bind="{ name: 'i' + item.id, id: 'i' + item.id + '_4' }" value="4" v-model="response.value" @change="handleChange" />
			<label v-html="mwpLabel[lang][3]" v-bind="{ for: 'i' + item.id + '_4' }"></label>
		</td>
		<td class="radiobuttons" @click="handleTd(5)">
			<input type="radio" v-bind="{ name: 'i' + item.id, id: 'i' + item.id + '_5' }" value="5" v-model="response.value" @change="handleChange" />
			<label v-html="mwpLabel[lang][4]" v-bind="{ for: 'i' + item.id + '_5' }"></label>
		</td>
	</tr>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "matwis-p-item",
	props: {
		item: Object,
		rowTitle: String,
		count: Number,
	},
	data() {
		return {
			response: {
				id: this.item.id,
				value: 0,
			},
		};
	},
	methods: {
		handleChange() {
			this.$emit("add:response", this.response);
		},
		handleTd(val) {
			this.response.value = val;
			this.handleChange();
		},
	},
	computed: mapGetters(["mwpLabel", "lang"]),
};
</script>

<style scoped>
label {
	display: none;
}
td {
	text-align: left;
	border-bottom: 1px dashed silver;
	font-size: 10pt;
}
.fragen {
	width: 35%;
}
.radiobuttons {
	text-align: center;
	width: 13%;
}
.title {
	font-weight: bold;
}
@media screen and (min-width: 1000px) {
	td {
		font-size: 12pt;
	}
}
@media screen and (max-width: 480px) {
	label {
		display: block;
		float: left;
	}
	.radiobuttons {
		width: 100%;
		text-align: left;
	}
	.fragen {
		padding-bottom: 0.5rem;
	}
	table.reflow tr td {
		float: left;
		clear: left;
		display: block;
		width: 100%;
	}
	table.reflow tr td:last-child {
		padding-bottom: 20px;
		border-bottom: 0;
	}
	table.reflow input {
		display: block;
		float: left;
		margin-right: 10px;
	}
}
</style>
